import { legacy_connect as connect } from 'react-redux';
import { Action, ActionCreator } from 'redux';
import { RootState } from '../../types';

import { changeEmailAddress } from '../../actions/settings';
import SettingsPage from '../components/SettingsPage';

export const stateToProps = (state: RootState) => ({
  error: state.settings.get('changeEmailError'),
  loading: state.settings.get('changeEmailRequest'),
  profileControlNumber: state.user.getIn(['data', 'profile_control_number']),
  userOrcid: state.user.getIn(['data', 'orcid']),
  userEmail: state.user.getIn(['data', 'email']),
});

const dispatchToProps = (dispatch: ActionCreator<Action>) => ({
  onChangeEmailAddress({ email }: { email: string }) {
    dispatch(changeEmailAddress({ email }));
  },
});

export default connect(stateToProps, dispatchToProps)(SettingsPage);
